
import colors from 'tailwindcss/colors'

export default {
  props: {
    hotel: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    toHotel: {},
    icon: {},
  }),
  methods: {
    setMarker(item) {
      this.icon = {
        path: 0,
        fillColor: item.types.includes('tourist_attraction')
          ? colors.green[700]
          : item.types.includes('restaurant')
          ? colors.blue[700]
          : colors.yellow[300],
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2,
        strokeOpacity: 0,
        scale: 10,
      }
      this.toHotel = item
    },
  },
}
